import { useTokens } from '@entities/token'
import type { CheckboxProps } from 'antd'
import { theme } from 'antd'
import { Switch } from 'antd'
import { Button, Card, Checkbox, Flex, Typography, Input } from 'antd'
import React, { useState } from 'react'
import FilterDropdown from '@shared/ui/filter-dropdown/filter-dropdown'
import { TableView } from '@pages/stock-buy-advertising/ui/TableView'
import { CardView } from '@pages/stock-buy-advertising/ui/CardView'
import useMobileView from '@shared/hooks/isMobile'
import { Link } from 'react-router-dom'
const { Search } = Input

const { Title } = Typography

export const BuyAdvertising = () => {
    const [checked, setChecked] = useState(true)
    const [checkedButton, setCheckedButton] = useState(1)
    const [switcherChecked, setSwitcherChecked] = useState(false)

    const isMobile = useMobileView()
    const { tokens } = useTokens()

    const {
        token: { colorPrimary }
    } = theme.useToken()

    const onChange: CheckboxProps['onChange'] = (e) => {
        console.log('checked = ', e.target.checked)
        setChecked(e.target.checked)
    }

    const onChangeButton = (btn: number) => {
        setCheckedButton(btn)
    }

    const onSwitcher = () => {
        setSwitcherChecked(!switcherChecked)
    }

    const onSwitcherButton = () => {
        setCheckedButton(checkedButton === 1 ? 2 : 1)
    }

    const onSearch = () => { }

    console.log(tokens, 'tokens')
    return (
        <Card>
            {!isMobile && (
                <Flex justify={'space-between'}>
                    <Title style={{ marginTop: 0 }} level={4}>
                        Купить рекламу
                    </Title>
                    <Button type="primary">
                        <Link to={'/stock/sell-stock'}>Продать рекламу в канале</Link>
                    </Button>
                </Flex>
            )}
            {isMobile ? (
                <Flex align={'center'} gap={'middle'} justify={'center'}>
                    <FilterDropdown />
                    <Search style={{ width: 170 }} placeholder="Введите код" onSearch={onSearch} enterButton />
                    <Switch
                        checkedChildren="Фикс"
                        unCheckedChildren="CPM"
                        checked={checkedButton === 1}
                        onChange={onSwitcherButton}
                    />
                </Flex>
            ) : (
                <Flex justify={'space-between'} align={'center'} gap={'small'}>
                    <Flex style={{ marginLeft: 149 }} align={'center'} gap={'small'}>
                        <Checkbox checked={checked} onChange={onChange}>
                            Каналы проверенные Telegaplan
                        </Checkbox>
                        <Flex gap={'small'}>
                            <Button
                                style={{
                                    borderColor: checkedButton === 1 ? colorPrimary : 'gray',
                                    color: checkedButton === 1 ? colorPrimary : 'gray'
                                }}
                                onClick={() => onChangeButton(1)}
                            >
                                СРМ
                            </Button>
                            <Button
                                style={{
                                    borderColor: checkedButton === 2 ? colorPrimary : 'gray',
                                    color: checkedButton === 2 ? colorPrimary : 'gray'
                                }}
                                onClick={() => onChangeButton(2)}
                            >
                                Фикс
                            </Button>
                        </Flex>
                        <Switch
                            checkedChildren="Вид"
                            unCheckedChildren="Вид"
                            checked={switcherChecked}
                            onChange={onSwitcher}
                        />
                        <FilterDropdown />
                    </Flex>
                    <Search
                        style={{ width: 300 }}
                        placeholder="Введите частный код, если вам его предоставили"
                        onSearch={onSearch}
                        enterButton
                    />
                </Flex>
            )}
            {switcherChecked ? <TableView /> : <CardView />}
        </Card>
    )
}
